import { render, staticRenderFns } from "./CustomerRelationship.vue?vue&type=template&id=571c63b5&scoped=true&"
import script from "./CustomerRelationship.vue?vue&type=script&lang=js&"
export * from "./CustomerRelationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571c63b5",
  null
  
)

export default component.exports